


import React, { useState } from 'react';
import { useEffect } from 'react';
import { Button, Table, TableBody, Stack, Dialog, DialogActions,Snackbar, Alert, DialogContent,TableCell, TableContainer, TableHead, TableRow, Paper, DialogTitle, Tabs, Autocomplete, InputAdornment, IconButton,Tab, Box,Grid ,TextField, Divider} from '@mui/material';

import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import { externaldeleteApi, externalgetApi } from '../../../services/external/externalApis';
import { AGENT_API_01 } from '../../../api/ApiModel';
import SearchIcon from '@mui/icons-material/Search';
import { useSelector, useDispatch } from "react-redux";
import {
  currencyFormat,
  currencyFormatLKR,
} from "../../../../src/utils/common/CurrencyFormat";
const Agentmap = ({ open, onClose, onConfirm }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState([]);
    const [error, setError] = useState(null);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE } = SYS_USER.USER_PARAM || {};
  const [tabIndex, setTabIndex] = useState(0);

   const [searchQuery, setSearchQuery] = useState(''); 


     const [expenses, setExpenses] = useState([]);
  const [expenseType, setExpenseType] = useState('');
  const [expenseRate, setExpenseRate] = useState('');

  // Add expense handler
  const handleAddExpense = () => {
    if (expenseType && expenseRate) {
      setExpenses([...expenses, { type: expenseType, rate: expenseRate }]);
      setExpenseType('');
      setExpenseRate('');
    }
  };

const [agentFees, setAgentFees] = useState("");
const [dtagentdet, setDtagentdet] = useState([
  {
    orderagentcode: "",
    amount: 0,
    remark: "",
    sts: "A"
  }
]);

useEffect(() => {
  setDtagentdet(
    expenses.length > 0
      ? expenses.map(exp => ({
          orderagentcode:  "",
          amount: exp.rate,
          remark: exp.type,
          sts: "A"
        }))
      : [
          {
            orderagentcode:  "",
            amount: 0,
            remark: "",
            sts: "A"
          }
        ]
  );
}, [expenses, agentFees,]);
// Add at the top of your component
const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState("");
// Add with your other state hooks
const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
const handleSuccessSnackbarClose = () => setOpenSuccessSnackbar(false);
const handleErrorSnackbarClose = () => setOpenErrorSnackbar(false);



const handleConfirmClick = () => {

  if (
    !selectedAgent ||
    !selectedAgent.FIRSTNAME ||
    !selectedAgent.LASTNAME ||
    !selectedAgent.NICPP
  ) {
    setSnackbarMessage("Please select the agent from search.");
    setOpenErrorSnackbar(true);
    return;
  }

  // Check Agent Fees
  if (!agentFees || agentFees.trim() === "") {
    setSnackbarMessage("Please enter Agent Fees.");
    setOpenErrorSnackbar(true);
    return;
  }
    if (onConfirm) onConfirm(dtagentdet, selectedAgent,agentFees);
    if (onClose) onClose();
    console.log("dtagentdet", dtagentdet);
    console.log("selectedAgent", selectedAgent.AGENTCODE);
  };

     useEffect(() => {
    const fetchData = async () => {
      try {
      const result = await externalgetApi(AGENT_API_01, "get", {
        COMPCODE,
          LOCCODE,
      

    
          STS: "A",
        });

        setData(result);
    
      console.log("result", result);
        
      } catch (err) {
        setError(err);
       
      }
    };

    fetchData();
  }, []);

 const [selectedAgent, setSelectedAgent] = useState(null);

  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
    const found = data.find((row) => row.FULLNAME === value);
    setSelectedAgent(found || null);
  };

const handlenumInputChange = (e) => {
  const { name, value } = e.target;
  const trimmedValue = typeof value === "string" ? value.trim() : value;

  // Prevent initial space only
  if (typeof value === "string" && value.length === 1 && value[0] === " ") {
    return;
  }

  // Limit to 30 characters
  if (typeof value === "string" && value.length > 30) {
    setError((prevError) => ({
      ...prevError,
      [name]: "Input cannot exceed 30 characters.",
    }));
    return;
  }

  // Validate numeric input (allow integers and floats)
  const isNumeric = /^[0-9]*\.?[0-9]*$/.test(value);
  if (!isNumeric) {
    setError((prevError) => ({
      ...prevError,
      [name]: "Input must contain only numbers or decimals.",
    }));
    return;
  }

  // Clear the value if it is "0" when focused
  if (value === "0") {
    setAgentFees("");
    return;
  }

  // Clear error if input is valid
  setError((prevError) => ({
    ...prevError,
    [name]: "",
  }));

  // Always update the value
  setAgentFees(value);
};


  const handleClearClick = () => {
  setSearchQuery('');
  setSelectedAgent(null);
  setAgentFees('');
  setExpenseType('');
  setExpenseRate('');
  setExpenses([]);
};

  return (
    <Grid container spacing={2} >
      {/* Search Bar at the Top */}
  
    
      <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item xs={12}>
  <Grid container justifyContent="flex-end" mr={10}>
    <Grid
      item
      xs={12}
      sm={12}
      md={6}
      lg={4}
      xl={4}
      sx={styles.appbar_grid_search}
    >
      <Autocomplete
        freeSolo
        id="sample-search"
        fullWidth
        disableClearable
        value={searchQuery}
        onInputChange={handleSearchChange}
        sx={styles.ipt_appbar_search_auto}
        options={data?.map((row) => row.FULLNAME) || []}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search by Agent Name.."
            size="small"
            sx={styles.ipt_appbar_search}
            InputProps={{
              ...params.InputProps,
              type: "search",
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton sx={styles.btn_appbar_search_icon}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </Grid>
  </Grid>
</Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                First Name
                </span>
              }
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="FIRSTNAME"
             value={selectedAgent?.FIRSTNAME || ""}
              // onChange={handleInputValidation}
              // error={Boolean(errors.GROUPNAME)}
              // helperText={errors.GROUPNAME}
            />
          </Grid> 
            <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
            Last Name
                </span>
              }
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="LASTNAME"
           value={selectedAgent?.LASTNAME || ""}
              // onChange={handleInputValidation}
              // error={Boolean(errors.GROUPNAME)}
              // helperText={errors.GROUPNAME}
            />
          </Grid> 
            <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  NIC<span style={{ color: "red" }}> *</span>
                </span>
              }
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="GROUPNAME"
              value={selectedAgent?.NICPP || ""}
              // onChange={handleInputValidation}
              // error={Boolean(errors.GROUPNAME)}
              // helperText={errors.GROUPNAME}
            />
          </Grid> 
        <Grid item lg={6} md={6} xs={12} sm={12}>
  <TextField
    label={
      <span>
        Agent Fees<span style={{ color: "red" }}> *</span>
      </span>
    }
    size="small"
    fullWidth
    variant="outlined"
    autoComplete="off"
    name="AGENTFEES"
   
    value={agentFees}
   onChange={handlenumInputChange}
    error={Boolean(error?.AGENTFEES)}
  helperText={error?.AGENTFEES}
  />
</Grid>
          
<Divider sx={{ width: '100%', margin: '20px 0' }} />

    <Grid container spacing={2} sx={styles.AI_container}>
        <Grid item lg={6} md={6} xs={12} sm={12}>
        <TextField
  label={<span>Expenses Type</span>}
  size="small"
  fullWidth
  variant="outlined"
  autoComplete="off"
  name="EXPENSE_TYPE"
  value={expenseType}
  onChange={(e) => {
    const value = e.target.value;
    if (typeof value === "string" && value.length > 30) {
      setError((prevError) => ({
        ...prevError,
        EXPENSE_TYPE: "Input cannot exceed 30 characters.",
      }));
      return;
    } else {
      setError((prevError) => ({
        ...prevError,
        EXPENSE_TYPE: "",
      }));
      setExpenseType(value);
    }
  }}
  error={Boolean(error?.EXPENSE_TYPE)}
  helperText={error?.EXPENSE_TYPE}
/>
        </Grid>
        <Grid item lg={3} md={3} xs={12} sm={12}>
      <TextField
  label={<span>Rate</span>}
  size="small"
  fullWidth
  variant="outlined"
  autoComplete="off"
  name="EXPENSE_RATE"
  value={expenseRate}
  onChange={(e) => {
    const value = e.target.value;
    // Limit to 30 characters
    if (typeof value === "string" && value.length > 30) {
      setError((prevError) => ({
        ...prevError,
        EXPENSE_RATE: "Input cannot exceed 30 characters.",
      }));
      return;
    }
    // Allow only numbers and decimals
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setExpenseRate(value);
      setError((prevError) => ({
        ...prevError,
        EXPENSE_RATE: "",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        EXPENSE_RATE: "Only numbers are allowed",
      }));
    }
  }}
  error={Boolean(error?.EXPENSE_RATE)}
  helperText={error?.EXPENSE_RATE}
/>   </Grid>
       
        <Grid item lg={3} md={3} xs={12} sm={12}>
          <Button
            onClick={handleAddExpense}
            color="primary"
            variant="contained"
            sx={styles.AI_button2}
          >
            Add
          </Button>
        </Grid>
    

          

        <Grid item xs={12} mt={2}>
  <TableContainer sx={styles.VI_ViewStyledPaper} component={Paper}>
    <Table size="small">
      <TableHead>
        <TableRow sx={{ background: theme.palette.background.paper }}>
          <TableCell sx={{ ...styles.AI_headtableCell, textTransform: "capitalize", }}>Expenses Type</TableCell>
          <TableCell sx={{ ...styles.AI_headtableCell, textTransform: "capitalize" }}>Rate</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {expenses.map((exp, idx) => (
          <TableRow key={idx}>
            <TableCell sx={{ ...styles.AI_tablecell,}}>{exp.type}</TableCell>
     <TableCell sx={{ ...styles.AI_tablecell, textAlign: "right" }}>
  {currencyFormatLKR(exp.rate)}
</TableCell>
          </TableRow>
        ))}
        {/* Total Row */}
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Total</TableCell>
          <TableCell sx={{ fontWeight: "bold",textAlign:"right" }}>
  {currencyFormatLKR(expenses.reduce((sum, exp) => sum + (parseFloat(exp.rate) || 0), 0))}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
</Grid>
   
      
     <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2,ml: 2 }}>
   <Grid item xs={12} sx={{ mt: 2 }}>
  <Stack direction="row" spacing={2} justifyContent="flex-end">
    <Button
      variant="outlined"
      sx={styles.AI_button1}
     onClick={handleClearClick}
    >
      Clear
    </Button>
    <Button
      variant="contained"
      sx={styles.AI_button2}
    onClick={handleConfirmClick}
    >
     Save
    </Button>
  </Stack>
</Grid>
   </Grid>   </Grid>  </Grid>
   <Snackbar
  open={openErrorSnackbar}
  message={snackbarMessage}
  autoHideDuration={6000}
  onClose={handleErrorSnackbarClose}
  anchorOrigin={{ vertical: "top", horizontal: "right" }}
  sx={{ top: "10%", right: "10%" }}
>
  <Alert
    onClose={handleErrorSnackbarClose}
    severity="error"
    sx={{ width: "100%" }}
  >
    {snackbarMessage || "Please fill out all fields before submitting."}
  </Alert>
</Snackbar>
<Snackbar
  open={openSuccessSnackbar}
  autoHideDuration={4000}
  onClose={handleSuccessSnackbarClose}
  anchorOrigin={{ vertical: "top", horizontal: "right" }}
  sx={{ top: "10%", right: "10%" }}
>
  <Alert
    onClose={handleSuccessSnackbarClose}
    severity="success"
    sx={{ width: "100%" }}
  >
    {snackbarMessage || "Expense added successfully."}
  </Alert>
</Snackbar>
</Grid>
   
  );
};

export default Agentmap;